<template>
    <transition name="fade">
        <div
            id="my-info-box"
            class="b3-modal"
            :class="store.state.infoBox.warning ? 'info-warn' : ''"
            v-if="store.state.infoBox.visible"
        >
            <div id="info-content-area">
                {{ store.state.infoBox.message}}
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'Info Box'
}
</script>

<style lang="scss">

#my-info-box {
    z-index: 1;
    position: fixed;
    border-radius: 5px;
    border: 1px solid black;
    top: 30%;
    width: 250px;
    background-color: white;
    box-shadow: 5px 5px black;
    #info-content-area {
        padding: 10px;
    }
    &.info-warn {
        border: 2px solid red;
        font-weight: bold;
    }
}


</style>